module.exports = __webpack_public_path__ + "static/media/edit-report.233e9077.svg";